import { useUiStrings } from '@/hooks/useUiStrings'
import DateInput from '@/components/DateInput'

interface AdminDateRangeProps {
  from: string
  to: string
  onFromChange: (value: string) => void
  onToChange: (value: string) => void
}

const DATE_INPUT_CLASS =
  'h-10 rounded-lg border border-[var(--border-hover)] bg-[var(--bg-secondary)] px-2.5 text-sm text-[var(--text-primary)] shadow-[var(--shadow-sm)] transition-colors focus:border-[var(--accent)] focus:outline-none focus:ring-2 focus:ring-[var(--ring)]'

/**
 * Paired from/to date controls used by the login-logs and meetings tabs.
 * Each field carries its own label and wraps independently so the toolbar
 * stays tidy on narrow screens. Emits raw YYYY-MM-DD strings; callers
 * convert to epoch ms.
 */
export default function AdminDateRange({
  from,
  to,
  onFromChange,
  onToChange,
}: AdminDateRangeProps) {
  const { t } = useUiStrings()

  return (
    <>
      <label className="flex min-w-[8.5rem] flex-1 flex-col gap-1 text-xs font-medium text-[var(--text-secondary)] sm:flex-none">
        {t.adminFilterDateFrom}
        <DateInput
          value={from}
          onChange={onFromChange}
          ariaLabel={t.adminFilterDateFrom}
          className={DATE_INPUT_CLASS}
        />
      </label>
      <label className="flex min-w-[8.5rem] flex-1 flex-col gap-1 text-xs font-medium text-[var(--text-secondary)] sm:flex-none">
        {t.adminFilterDateTo}
        <DateInput
          value={to}
          onChange={onToChange}
          ariaLabel={t.adminFilterDateTo}
          className={DATE_INPUT_CLASS}
        />
      </label>
    </>
  )
}
